$(function () {
    var section = $('.hindle-side-widget.-archives');

    if (section.length === 0) {
        return;
    }

    var headings = section.find('.year');
    var archives = section.find('.months');

    headings.each(function (index, element) {
        var heading = $(element);
        var archive = heading.next('.months');
        var link = $('<a href="#" class="year"></a>');

        // Replace non-linked heading with focusable linked heading
        link.html(heading.html());
        heading.replaceWith(link);

        // Toggle archive visibility on click
        link.on('click', function (e) {
            e.preventDefault();
            archive.slideToggle();
            archives.not(archive).slideUp();
        });
    });

    // Hide all except the most recent year on page load
    archives.slice(1).hide();
});
